import dayjs from 'dayjs';

import srb from 'dayjs/locale/sr';

dayjs.locale(srb);

// Add any plugins you want to use with Day.js
/* import advancedFormat from 'dayjs/plugin/advancedFormat'
import weekday from 'dayjs/plugin/weekday'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import isoWeek from 'dayjs/plugin/isoWeek'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(weekOfYear)
dayjs.extend(relativeTime)
dayjs.extend(customParseFormat)
dayjs.extend(quarterOfYear)
dayjs.extend(localizedFormat)
dayjs.extend(isoWeek) */

export default dayjs;
